import { render, staticRenderFns } from "./dateSubgroupsAttMonitoring.vue?vue&type=template&id=1904b25e"
import script from "./dateSubgroupsAttMonitoring.vue?vue&type=script&lang=js"
export * from "./dateSubgroupsAttMonitoring.vue?vue&type=script&lang=js"
import style0 from "./dateSubgroupsAttMonitoring.vue?vue&type=style&index=0&id=1904b25e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports